// Ð§Ð¸ÑÑÑÐµ ÑÑÐ½ÐºÑÐ¸Ð¸ Ð²ÐºÐ»Ð°Ð´Ð¾Ðº Â«Ð¢Ð°Ð±Ð»Ð¸ÑÐ°Â» Ð¸ Â«ÐÑÑÐ¾ÑÐ¸ÑÂ» Ð¿ÑÐ°Ð¹ÑÐ°: Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ¸, Ð´Ð¸ÑÑ ÑÐµÐ½, ÑÐ¸Ð»ÑÑÑ.
// ÐÐ¾Ð³Ð¸ÐºÐ° ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ð¸ â doscar_back/docs/price-sheet-sync.md

export const money = (v) => (v == null ? '' : Number(v).toLocaleString('ru-RU'));

// ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ ÑÐµÐ½Ñ Ð² Ð¿ÑÐ¾ÑÐµÐ½ÑÐ°Ñ; null â ÑÑÐ°Ð²Ð½Ð¸Ð²Ð°ÑÑ Ð½Ðµ Ñ ÑÐµÐ¼ (Ð½Ð¾Ð²Ð°Ñ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ)
export const deltaPercent = (oldPrice, newPrice) => {
  if (oldPrice == null || newPrice == null || !oldPrice) return null;
  return ((newPrice - oldPrice) / oldPrice) * 100;
};

// Â«+300 000 (+3,0%)Â» â ÑÐ²Ð½ÑÐ¹ Ð´Ð¸ÑÑ Ð²Ð¼ÐµÑÑÐ¾ Ð´Ð²ÑÑ ÑÐ¸ÑÐµÐ», ÐºÐ¾ÑÐ¾ÑÑÐµ Ð½Ð°Ð´Ð¾ Ð²ÑÑÐ¸ÑÐ°ÑÑ Ð² ÑÐ¼Ðµ
export const deltaText = (oldPrice, newPrice) => {
  if (oldPrice == null || newPrice == null) return 'Ð½Ð¾Ð²Ð°Ñ';
  const diff = newPrice - oldPrice;
  if (diff === 0) return 'Ð±ÐµÐ· Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹';
  const sign = diff > 0 ? '+' : 'â';
  const pct = Math.abs(deltaPercent(oldPrice, newPrice)).toFixed(1).replace('.', ',');
  return `${sign}${money(Math.abs(diff))} (${sign}${pct}%)`;
};

// Ð¡ÐºÐ°ÑÐ¾Ðº Ð±Ð¾Ð»ÑÑÐµ ÑÑÐ¾Ð³Ð¾ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð±ÑÐº Ð¾ÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑ Ð´Ð¾ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ
export const BIG_JUMP = 10;

export const isBigJump = (oldPrice, newPrice) => {
  const pct = deltaPercent(oldPrice, newPrice);
  return pct != null && Math.abs(pct) > BIG_JUMP;
};

export const KIND_LABELS = {
  created: 'Ð½Ð¾Ð²Ð°Ñ',
  changed: 'Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð°',
  held: 'Ð¶Ð´ÑÑ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ',
  problem: 'Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼Ð°',
};

export const STATUS_LABELS = {
  nochange: 'Ð±ÐµÐ· Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹',
  applied: 'Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¾',
  partial: 'Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¾ ÑÐ°ÑÑÐ¸ÑÐ½Ð¾',
  attention: 'Ð½ÑÐ¶Ð½Ð¾ Ð²Ð½Ð¸Ð¼Ð°Ð½Ð¸Ðµ',
  blocked: 'Ð¾ÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð¾',
  error: 'Ð¾ÑÐ¸Ð±ÐºÐ°',
};

// ÐÑÐ¸ÑÐ¸Ð½Ð° Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼Ñ ÑÐµÐ»Ð¾Ð²ÐµÑÐµÑÐºÐ¸Ð¼ ÑÐ·ÑÐºÐ¾Ð¼: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð½Ðµ Ð½ÑÐ¶Ð½Ð¾ Ð·Ð½Ð°ÑÑ, ÑÑÐ¾ ÑÐ°ÐºÐ¾Ðµ Â«Ð½ÐµÐ¾Ð´Ð½Ð¾Ð·Ð½Ð°ÑÐ½Ð°Â»
export const plainReason = (reason) => {
  const r = reason || '';
  let m;
  if ((m = r.match(/^Ð¼Ð°ÑÐºÐ° Â«(.+)Â» Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð°/))) return `ÐÐ°ÑÐºÐ¸ Â«${m[1]}Â» Ð½ÐµÑ Ð² Ð½Ð°ÑÐµÐ¼ ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ðµ`;
  if ((m = r.match(/^Ð¼Ð°ÑÐºÐ° Â«(.+)Â» Ð½ÐµÐ¾Ð´Ð½Ð¾Ð·Ð½Ð°ÑÐ½Ð°/))) return `ÐÐ°ÑÐºÐµ Â«${m[1]}Â» Ð¿Ð¾Ð´ÑÐ¾Ð´Ð¸Ñ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ Ð²Ð°ÑÐ¸Ð°Ð½ÑÐ¾Ð² Ð² ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ðµ`;
  if ((m = r.match(/^Ð¼Ð¾Ð´ÐµÐ»Ñ Â«(.+)Â» Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð° Ñ (.+)$/))) return `Ð£ Ð¼Ð°ÑÐºÐ¸ ${m[2]} Ð½ÐµÑ Ð¼Ð¾Ð´ÐµÐ»Ð¸ Â«${m[1]}Â»`;
  if ((m = r.match(/^Ð¼Ð¾Ð´ÐµÐ»Ñ Â«(.+)Â» Ð½ÐµÐ¾Ð´Ð½Ð¾Ð·Ð½Ð°ÑÐ½Ð°/))) return `ÐÐ¾Ð´ÐµÐ»Ð¸ Â«${m[1]}Â» Ð¿Ð¾Ð´ÑÐ¾Ð´Ð¸Ñ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ Ð²Ð°ÑÐ¸Ð°Ð½ÑÐ¾Ð² Ð² ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ðµ`;
  if ((m = r.match(/^ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ Â«(.+)Â» Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð° Ñ (.+)$/))) return `Ð£ Ð¼Ð¾Ð´ÐµÐ»Ð¸ ${m[2]} Ð½ÐµÑ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ Â«${m[1]}Â»`;
  if ((m = r.match(/^ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ Â«(.+)Â» Ð½ÐµÐ¾Ð´Ð½Ð¾Ð·Ð½Ð°ÑÐ½Ð°/))) return `ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ Â«${m[1]}Â» Ð¿Ð¾Ð´ÑÐ¾Ð´Ð¸Ñ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ Ð²Ð°ÑÐ¸Ð°Ð½ÑÐ¾Ð² Ð² ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ðµ`;
  if (/Ð¸Ð·Ð¼ÐµÐ½Ð¸Ð»Ð¾ÑÑ Ñ Ð¼Ð¾Ð¼ÐµÐ½ÑÐ° Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸/.test(r)) return 'Ð¢ÐµÐºÑÑ ÑÑÑÐ¾ÐºÐ¸ Ð¸Ð·Ð¼ÐµÐ½Ð¸Ð»ÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸: Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÑ Ð·Ð°Ð½Ð¾Ð²Ð¾';
  if (/Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÑÑÐ¾Ðº Ð½Ð° Ð¾Ð´Ð½Ñ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ/.test(r)) return 'Ð ÑÐ°Ð±Ð»Ð¸ÑÐµ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÑÑÐ¾Ðº Ð½Ð° Ð¾Ð´Ð½Ñ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ñ ÑÐ°Ð·Ð½Ð¾Ð¹ ÑÐµÐ½Ð¾Ð¹';
  if (/Ð²Ð½Ðµ ÑÐ°Ð·ÑÐ¼Ð½ÑÑ Ð¿ÑÐµÐ´ÐµÐ»Ð¾Ð²/.test(r)) return 'Ð¦ÐµÐ½Ð° Ð²ÑÐ³Ð»ÑÐ´Ð¸Ñ Ð¾ÑÐ¸Ð±Ð¾ÑÐ½Ð¾Ð¹ (ÑÐ»Ð¸ÑÐºÐ¾Ð¼ Ð¼Ð°Ð»Ð° Ð¸Ð»Ð¸ Ð²ÐµÐ»Ð¸ÐºÐ°)';
  if (/Ð½Ðµ ÑÐ°Ð·Ð¾Ð±ÑÐ°Ð½Ð°/.test(r)) return 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿ÑÐ¾ÑÐ¸ÑÐ°ÑÑ ÑÐµÐ½Ñ Ð² ÑÑÐ¾Ð¹ ÑÑÑÐ¾ÐºÐµ';
  return r;
};

// Ð¢Ð¸Ð¿ Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼Ñ Ð¿Ð¾ Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ°Ð¼: ÐµÑÑÑ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ñ ÑÐ°ÐºÐ¾Ð¹ Ð¶Ðµ ÑÐµÐ½Ð¾Ð¹ / Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¸ ÐµÑÑÑ, Ð½Ð¾ ÑÐµÐ½Ð° Ð´ÑÑÐ³Ð°Ñ / Ð¿Ð¾Ð´ÑÐºÐ°Ð·Ð¾Ðº Ð½ÐµÑ
export const problemKind = (p) => {
  const s = p.suggestions || [];
  if (s.some((x) => x.priceMatches)) return 'exact';
  return s.length > 0 ? 'differs' : 'none';
};

// ÐÐ´Ð¸Ð½ÑÑÐ²ÐµÐ½Ð½Ð°Ñ Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ° Ñ ÑÐ¾Ð²Ð¿Ð°Ð²ÑÐµÐ¹ ÑÐµÐ½Ð¾Ð¹ â ÐµÑ Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿ÑÐ¸Ð²ÑÐ·Ð°ÑÑ Ð±ÐµÐ· ÑÐ°Ð·Ð´ÑÐ¼Ð¸Ð¹ (Ð¸ Ð¼Ð°ÑÑÐ¾Ð²Ð¾)
export const singleExact = (p) => {
  const exact = (p.suggestions || []).filter((x) => x.priceMatches);
  return exact.length === 1 ? exact[0] : null;
};

// Ð¡ÑÐ°ÑÑÑ Ð¿ÑÐ¸Ð²ÑÐ·Ð°Ð½Ð½Ð¾Ð¹ ÑÑÑÐ¾ÐºÐ¸ (Ð²ÐºÐ»Ð°Ð´ÐºÐ° Â«ÐÑÐ¸Ð²ÑÐ·ÐºÐ¸Â») Ð¸ ÑÑÐ¾ Ð¾Ð½ Ð·Ð½Ð°ÑÐ¸Ñ Ð´Ð»Ñ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ°
export const LINK_STATUS = {
  ok: { label: 'ÑÑÐ¾Ð´Ð¸ÑÑÑ', hint: 'Ð¦ÐµÐ½Ð° Ð² ÑÐ°Ð±Ð»Ð¸ÑÐµ ÑÐ°Ð²Ð½Ð° ÑÐµÐ½Ðµ Ð¿ÑÐ°Ð²Ð¸Ð»Ð°: Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÑÑ Ð½ÐµÑÐµÐ³Ð¾.' },
  price_differs: {
    label: 'ÑÐµÐ½Ð° Ð¾ÑÐ»Ð¸ÑÐ°ÐµÑÑÑ',
    hint: 'Ð¦ÐµÐ½Ð° Ð² ÑÐ°Ð±Ð»Ð¸ÑÐµ Ð´ÑÑÐ³Ð°Ñ, ÑÐµÐ¼ Ñ Ð¿ÑÐ°Ð²Ð¸Ð»Ð°. ÐÑÐ¸ Â«ÐÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÂ» Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð¿Ð¾Ð»ÑÑÐ¸Ñ ÑÐµÐ½Ñ Ð¸Ð· ÑÐ°Ð±Ð»Ð¸ÑÑ.',
  },
  no_rule: {
    label: 'Ð¿ÑÐ°Ð²Ð¸Ð»Ð° ÐµÑÑ Ð½ÐµÑ',
    hint: 'ÐÑÐ¸Ð²ÑÐ·Ð°Ð½Ð½Ð¾Ð³Ð¾ Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð² Ð¿ÑÐ¸ÐºÐ°Ð·Ð°Ñ Ð¿Ð¾ÐºÐ° Ð½ÐµÑ. ÐÑÐ¸ Â«ÐÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÂ» Ð¾Ð½Ð¾ Ð±ÑÐ´ÐµÑ ÑÐ¾Ð·Ð´Ð°Ð½Ð¾.',
  },
  row_changed: {
    label: 'ÑÑÑÐ¾ÐºÐ° Ð¸Ð·Ð¼ÐµÐ½Ð¸Ð»Ð°ÑÑ',
    hint: 'Ð¢ÐµÐºÑÑ ÑÑÑÐ¾ÐºÐ¸ Ð² ÑÐ°Ð±Ð»Ð¸ÑÐµ Ð¸Ð·Ð¼ÐµÐ½Ð¸Ð»ÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ° Ð½Ðµ Ð´ÐµÐ¹ÑÑÐ²ÑÐµÑ. ÐÑÐ¾Ð²ÐµÑÑÑÐµ ÑÑÑÐ¾ÐºÑ Ð¸ ÑÐ¾ÑÑÐ°Ð½Ð¸ÑÐµ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÑ Ð·Ð°Ð½Ð¾Ð²Ð¾.',
  },
  row_missing: {
    label: 'Ð½ÐµÑ Ð² ÑÐ°Ð±Ð»Ð¸ÑÐµ',
    hint: 'Ð¡ÑÑÐ¾ÐºÐ¸ Ñ ÑÐ°ÐºÐ¸Ð¼ ID Ð² ÑÐ°Ð±Ð»Ð¸ÑÐµ Ð±Ð¾Ð»ÑÑÐµ Ð½ÐµÑ (Ð¸Ð»Ð¸ ÑÐ°Ð±Ð»Ð¸ÑÐ° Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ð°). ÐÑÐ¸Ð²ÑÐ·ÐºÑ Ð¼Ð¾Ð¶Ð½Ð¾ ÑÐ½ÑÑÑ.',
  },
  ignored: { label: 'Ð½Ðµ ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÑÐµÑÑÑ', hint: 'Ð¡ÑÑÐ¾ÐºÐ° Ð¸ÑÐºÐ»ÑÑÐµÐ½Ð° Ð¸Ð· ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ð¸. ÐÐ¾Ð¶Ð½Ð¾ Ð²ÐµÑÐ½ÑÑÑ ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹ Â«ÐÐµÑÐ½ÑÑÑ Ð² ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸ÑÂ».' },
};

export const LINK_SOURCE = { auto: 'Ð°Ð²ÑÐ¾', manual: 'Ð²ÑÑÑÐ½ÑÑ', ignored: 'Ð¸ÑÐºÐ»ÑÑÐµÐ½Ð°' };

// ÐÑÐ¸Ð²ÑÐ·ÐºÐ¸, Ð½Ð° ÐºÐ¾ÑÐ¾ÑÑÐµ ÑÑÐ¾Ð¸Ñ Ð¿Ð¾ÑÐ¼Ð¾ÑÑÐµÑÑ: Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ ÑÐ»Ð¾Ð¼Ð°Ð½Ð¾, Ð½Ð¾ ÑÑÐ¾-ÑÐ¾ Ð½Ðµ ÑÑÐ¾Ð´Ð¸ÑÑÑ Ð¸Ð»Ð¸ Ð½Ðµ Ð´ÐµÐ¹ÑÑÐ²ÑÐµÑ
export const linkNeedsAttention = (status) => ['row_changed', 'row_missing', 'no_rule', 'price_differs'].includes(status);

// ÐÑÐºÐ°ÑÐ¸ÑÑ Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÐ½Ð½ÑÐ¹ Ð·Ð°Ð¿ÑÑÐº, ÐºÐ¾ÑÐ¾ÑÑÐ¹ ÐµÑÑ Ð½Ðµ Ð¾ÑÐºÐ°ÑÑÐ²Ð°Ð»Ð¸
export const canRollback = (run) => ['applied', 'partial'].includes(run.status) && !run.revertedAt;

// Ð¡ÐºÐ¾Ð»ÑÐºÐ¾ Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÐ½Ð½ÑÑ Ð¸ Ð½Ðµ Ð¾ÑÐºÐ°ÑÐµÐ½Ð½ÑÑ Ð·Ð°Ð¿ÑÑÐºÐ¾Ð² Ð½Ð¾Ð²ÐµÐµ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾: ÑÑÐ¾Ð»ÑÐºÐ¾ Ð¾ÑÐ¼ÐµÐ½Ð¸Ñ Â«ÐÐµÑÐ½ÑÑÑ Ðº Ð²ÐµÑÑÐ¸Ð¸Â»
export const laterRollbackable = (runs, runId) =>
  (runs || []).filter((x) => x.run.id > runId && canRollback(x.run)).length;

export const formatDateTime = (iso) => (iso ? new Date(iso).toLocaleString('ru-RU') : '');

// Â«02.11 13:51Â» â Ð´Ð»Ñ Ð¿Ð»Ð¾ÑÐ½ÑÑ ÑÐ°Ð±Ð»Ð¸Ñ, Ð³Ð´Ðµ Ð³Ð¾Ð´ Ð¸ ÑÐµÐºÑÐ½Ð´Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ð¼ÐµÑÐ°ÑÑ
export const formatShort = (iso) =>
  iso
    ? new Date(iso).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
    : '';

// ÐÐ¾ÑÐ¾ÑÐºÐ°Ñ ÑÐ²Ð¾Ð´ÐºÐ° Ð·Ð°Ð¿ÑÑÐºÐ° Ð´Ð»Ñ ÑÑÑÐ¾ÐºÐ¸ ÑÐ¿Ð¸ÑÐºÐ°
export const summarizeRun = (run) =>
  [
    run.created ? `Ð½Ð¾Ð²ÑÑ ${run.created}` : null,
    run.changed ? `Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¾ ${run.changed}` : null,
    run.held ? `Ð¶Ð´ÑÑ ${run.held}` : null,
    run.problems ? `Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼ ${run.problems}` : null,
  ]
    .filter(Boolean)
    .join(' Â· ');

// Ð¤Ð¸Ð»ÑÑÑ Ð¸ÑÑÐ¾ÑÐ¸Ð¸: Ð¿Ð¾ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ¸ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¸, Ð¼Ð°ÑÐºÐµ, ID ÑÑÑÐ¾ÐºÐ¸ Ð¸ Ð¿ÑÐ¸Ð¼ÐµÑÐ°Ð½Ð¸Ñ
export const matchesFilter = (change, query) => {
  const q = (query || '').trim().toLowerCase();
  if (!q) return true;
  return [change.label, change.mark, change.sheetKey, change.note].some((v) => (v || '').toLowerCase().includes(q));
};

// Ð¢Ð¾Ð»ÑÐºÐ¾ ÑÐ¾, ÑÑÐ¾ ÑÐµÐ°Ð»ÑÐ½Ð¾ Ð¼ÐµÐ½ÑÐµÑ ÑÐµÐ½Ñ: Ð±ÐµÐ· ÑÑÑÐ¾Ðº-Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼
export const priceChanges = (changes) => changes.filter((c) => c.kind !== 'problem');
